import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ApplicationChainPageRoutingModule } from './application-chain-routing.module';
import { ApplicationProgramComponentsModule } from '@app/modules/application/application.program.module';
import { ApplicationChainPage } from './application-chain.page';
import { SharedSidebarComponentsModule } from '@app/shared/components/sidebar.module';
import { ApplicationChainComponentsModule } from '../../application-chain.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ApplicationChainPageRoutingModule,
        SharedSidebarComponentsModule,
        ApplicationChainComponentsModule,
        FontAwesomeModule,
        ApplicationProgramComponentsModule,
    ],
    declarations: [ApplicationChainPage],
})
export class ApplicationChainPageModule {}
